import { render, staticRenderFns } from "./DomainInspect.vue?vue&type=template&id=193769dd&scoped=true"
import script from "./DomainInspect.vue?vue&type=script&lang=js"
export * from "./DomainInspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193769dd",
  null
  
)

export default component.exports